var GET_OTHER_COLORS = true;

theme.getOtherColors = function() {
  if(!GET_OTHER_COLORS) return;
  if(theme.isMobile()) return;
  var checked = [];
  $('#Collection .product-card:not(.colors-found)').each(function(i,card) {
    var productStyle = $(card).data('product-style'),
        productStyleHandle = theme.toHandle(productStyle);
    if(checked.indexOf(productStyle) > -1) return true;
    $.getJSON(`/search?q=${productStyleHandle}&type=product&view=json`,function(data) {
      if(data.length <= 1) return; 
      $.each(data,function(i,item) {
        var itemTitle = item.title.split(' | '),
            myStyle = itemTitle[0];
        
        if(myStyle != productStyle) return true;
        var myColor = itemTitle[1],
            myImage = item.images[0],
            myColorHandle = theme.toHandle(myColor),
            swatchImage = theme.swatchUrl.replace('swatch',myColorHandle);
        $(`.product-card[data-product-style="${productStyle}"]`)
        .find('.other-colors')
        .fadeIn()
        .append(`<a data-image="${myImage}" href="/products/${item.handle}" class="color-swatch" style="background-image:url(${swatchImage})">
        	<span class="visually-hidden">${myColor}</span>
        </a>`);
      });
    });
    checked.push(productStyle);
  });
  $(document).on('mouseenter','.product-card .color-swatch', function() {
    var $t = $(this);
    var img = $t.data('image');
    var newSize = theme.imgURL(img,'800x');
    var $el = $t.closest('.product-card').find('.product-card__other-color');
    $el.empty().append(`<img class="lazyload lazyfade" data-src="${newSize}" />`);
    $el.addClass('show');
  });

  $(document).on('mouseleave','.product-card .color-swatch', function() {
    var $el = $(this)
    .closest('.product-card')
    .find('.product-card__other-color')
    .removeClass('show');
  });
};

theme.buildFilters = function() {
  var tags = $('.collection-sidebar').data('tags'),
      categories = [],
      filters = [],
      currentTags = $('.collection-sidebar').data('current-tags'),
      categoriesObject = [];
  $.each(tags,function(i,tag) {
    if(tag.indexOf('filter:') == -1) return true;
    
    var tagSplit = tag.split(':'),
        category = tagSplit[1],
        tagActual = tagSplit[2],
        categoryIndex = categories.indexOf(category),
        categoryHandle = theme.toHandle(category);
    
    var checked = (currentTags != 'false' && currentTags.indexOf(tag) > -1) ? 'checked' : '';
    
    if(categoryIndex == -1) {
      categories.push(category);
      var myObj = {
        category: category,
        filters: []
      }
      categoriesObject.push(myObj);
      categoryIndex = 0;
      var filterElement = $(`<div class="filter-block" data-filter-type="${category}">
		<button aria-expanded="false" aria-controls="filter-list--${categoryHandle}" class="filter-heading h5">${category}</button>
			<ul id="filter-list--${categoryHandle}" class="filter-list" style="display: none;" aria-hidden="true"></ul>
	  </div>`).appendTo('.collection-filters');
    } 
    
    if(filters.indexOf(tagActual) == -1) {
      filters.push(tagActual);
      $.each(categoriesObject,function(i,obj) {
        var colorExtras = '';
        if(category == 'Color') {
          var colorImg = `${theme.filePrefix}${theme.toHandle(tagActual)}.png`;
          colorExtras = `<span class="browse-filter__chip">
			<img alt="${tagActual} Swatch" class="browse-filter__chip-image lazyfade lazyload" data-src="${colorImg}" width="29" height="29" src="${colorImg}">
		  </span>`;
        }
        if(obj.category == category) {
          obj.filters.push(tagActual);
          var tagNoSpaces = tag.replace(/\s+/g,'-');
          var filterLink = $(`<li>
			<input id="filter-${tag}" class="filter-input" type="checkbox" name="${categoryHandle}" value="${tagNoSpaces}" ${checked}>
			<label for="filter-${tag}">${colorExtras}<span>${tagActual}</span></label>
		  </li>`)
          .appendTo(`.filter-block[data-filter-type="${category}"] .filter-list`);
        }
      });
    }
    
    
  });
  console.log(categories);
  theme.buildSizeFilters();
  
  $(document).on('click','.filter-heading',function(e) {
    e.preventDefault();
    var $t = $(this),
        target = '#'+$t.attr('aria-controls'),
        x = $t.attr('aria-expanded') == 'true' ? false : true;
    $t.attr('aria-expanded',x);
    if(x) {
      $(target).slideDown('fast').removeAttr('aria-hidden');
    } else {
      $(target).slideUp('fast').attr('aria-hidden',true);
    }
    
  });
  
  $(".filter-input").change(function(e){
    $(".filter-input[name='"+$(this).attr("name")+"']").not(this).prop("checked",false);
    if(theme.isMobile()) return;
    e.preventDefault();
    theme.applyFilters();
  });
  
  $(document).on('click','.clear-filters',function() {
    $('.collection-filters .filter-input').prop('checked',false).eq(0).trigger('change');
    theme.applyFilters();
  });
  

  
  var currentUrl = window.location.href
  if(currentUrl.indexOf('_f:') > -1) {
  }
  
  $('#filter-form').submit(function(e) {
    e.preventDefault();
    var selected = $(this).find('input:checked').map(function() {
      return $(this).val();
    }).get();
    var collection = $(this).data('collection-handle'),
        sort = $('#SortBy').val(),
        tags = selected.length ? selected.join('+') : '',
        newUrl = `/collections/${collection}/${tags}?sort_by=${sort}`;
    $.get(newUrl,function(data) {
      $('#Collection').empty().html($(data).find('#Collection').html());
      theme.hideCollectionItems();
      theme.closeDrawer('#filter-drawer');
      theme.updateURL(newUrl);
      theme.getOtherColors();
      $('.collection-hero__wrapper').hide();
      theme.checkPPR();
    },'html');
  });
  
  $(document).on('click','button[aria-controls="filter-drawer"]',function(e) {
    e.preventDefault();
    theme.openDrawer('#filter-drawer','left');
    window.theActiveElement = this;
  });
  
  $(document).on('click','.filter-drawer__close',function() {
    theme.closeDrawer('#filter-drawer');
  });
  
  $(document).on('click','.filters-reset',function(e) {
    e.preventDefault();
    $('.filter-input').prop('checked',false);
    $('#SortBy').val($('#SortBy').data('default-sortby'));
    var newUrl = '/collections/'+$('#filter-form').data('collection-handle')
    $.get(newUrl,function(data) {
      $('#Collection').empty().html($(data).find('#Collection').html());
      theme.closeDrawer('#filter-drawer');
      theme.updateURL(newUrl);
      theme.getOtherColors();
      $('.collection-hero__wrapper').show();
      theme.checkPPR();
    },'html');
  });
  $(document).on('click','.apply-filters',function() {
    theme.applyFilters();
    
  });
};

theme.applyFilters = function() {
  var selected = $('.collection-sidebar').find('.collection-filters input:checked').map(function() {
    return $(this).val();
  }).get();
  var collection = $('.collection-sidebar').data('collection-handle'),
      sort = $('input[name="sort"]:checked').val(),
      tags = selected.length ? selected.join('+') : '',
      newUrl = `/collections/${collection}/${tags}?sort_by=${sort}`;

  selected.length ? $('.clear-filters').addClass('is--visible') : $('.clear-filters').removeClass('is--visible');
  $.get(newUrl+'&view=ajax',function(data) {
    $('#CollectionAjaxResult').empty().html($(data).find('#CollectionAjaxResult').html());
    theme.hideCollectionItems();
    theme.updateURL(newUrl);
    $('.collection-hero__wrapper').hide();
    theme.checkPPR();
    if(theme.isMobile()) {
      $('.collection-sidebar').removeClass('is--open');
    }
  },'html');
};

theme.hideCollectionItems = function() {
  if($('#filter-list--size input:checked').length) {
    var selectedSize = $('#filter-list--size input:checked').val();
    $('.product-card').each(function(i,product) {
      var myOptions = $(product).data('options-json'),
          myVariants = $(product).data('variants-json'),
          sizeIndex = false,
          available = true;
      $.each(myOptions,function(o,option) {
        if(option == 'Size') {
          sizeIndex = "option"+(o+1);
          return;
        }
      });
      $.each(myVariants,function(v,variant) {
        if(variant[sizeIndex] == selectedSize.toUpperCase() && variant.available != true) {
          $(product).parent().hide();
          return;
        }
      });
    });
  }
};

theme.buildSizeFilters = function() {
  var sizes = [
    	'xs',
    	's',
    	's/m',
    	'm',
    	'm/l',
    	'l',
    	'l/xl',
    	'xl',
    	'xxl',
    	'one size',
    	'one size plus',
    	'one size petite'
  	  ],
      category = 'Size',
      categoryHandle = 'size',
      currentTags = $('.collection-sidebar').data('current-tags');
  
  
  var tags = $('.collection-sidebar').data('tags');
  var filterElement = $(`<div class="filter-block" data-filter-type="${category}">
		<button aria-expanded="false" aria-controls="filter-list--${categoryHandle}" class="filter-heading h5">${category}</button>
			<ul id="filter-list--${categoryHandle}" class="filter-list" style="display: none;" aria-hidden="true"></ul>
	  </div>`).appendTo('.collection-filters');
  
  $.each(sizes,function(i,tag) {
    var checked = (currentTags != 'false' && currentTags.indexOf(tag) > -1) ? 'checked' : '';
    if(tags.indexOf(tag) == -1) return true;
    
    var filterLink = $(`<li>
    <input id="filter-${tag}" class="filter-input" type="checkbox" name="${categoryHandle}" value="${tag.split(' ').join('-').replace('/','-')}" ${checked}>
    <label for="filter-${tag}">${tag.toUpperCase()}</label>
    </li>`)
    .appendTo(`.filter-block[data-filter-type="${category}"] .filter-list`);
  });
};

theme.setPPR = function(n) {
  console.log('setPPR:',n);
  var $gridItems = $('#CollectionAjaxContent .grid__item:not(.marketing-tile__wide)'),
      newClass = '',
      removeClass = '',
      $marketingTilesWide = $('#CollectionAjaxContent .marketing-tile__wide');
  
  switch(n) {
    case 1:
      newClass = 'small--one-whole';
      removeClass = 'small--one-half';
      break;
    case 2:
      newClass = 'small--one-half';
      removeClass = 'small--one-whole';
      break;
    case 3:
      newClass = 'medium-up--one-third';
      removeClass = 'medium-up--one-quarter';
      break;
    case 4:
      newClass = 'medium-up--one-quarter';
      removeClass = 'medium-up--one-third';
      break;
  }
  
  $gridItems.removeClass(removeClass).addClass(newClass);
  $('.products-per-row').removeClass('active');
  $(`.products-per-row[data-products-per-row="${n}"]`).addClass('active');
  
  if($marketingTilesWide.length) {
    if(n == 1 || n == 3) {
      $marketingTilesWide.hide();
    } else {
      $marketingTilesWide.show();
    }
  }
  
};

theme.checkPPR = function() {
  var ppr = theme.getCookie('ppr');
  console.log('PPR:',ppr);
  if(ppr) {
    theme.setPPR(parseFloat(ppr));
  }
};

$(function() {
  
  theme.buildFilters();
  theme.hideCollectionItems();
  theme.checkPPR();
  
  $(document).on('click','.products-per-row',function(e) {
    e.preventDefault();
    var $t = $(this),
        productsPerRow = parseFloat($t.data('products-per-row'));
    theme.setCookie('ppr',productsPerRow,5);
    theme.setPPR(productsPerRow);
    
  });
  
  $(document).on('click','#small--filter-open',function(e) {
    e.preventDefault();
    $('.collection-sidebar').addClass('is--open');
  });
  $(document).on('click','.close--collection-sidebar',function(e) {
    $('.collection-sidebar').removeClass('is--open');
  });
  
  $('.marketing-tile__wide').each(function(t,tile) {
    var $g = $('.grid-product').eq(0).find('.slider-wrapper'),
        h = $g.height(),
        w = $g.width()*2,
        gridGutter = 20,
    	widePadding = ((Math.round(h) / Math.round(w+gridGutter)) * 100).toFixed(2);
    $(tile).find('.image-background-element').css('paddingTop',widePadding+'%');
  });
  
});

var resizeTimeout = false,
    resizeDelay = 250;
window.addEventListener('resize', function() {
  // clear the timeout
  clearTimeout(resizeTimeout);
  // start timing for event "completion"
  resizeTimeout = setTimeout(function() {
    if(theme.isMobile()) {
      $('.products-per-row[data-products-per-row="2"]').trigger('click');
    } else {
      $('.products-per-row[data-products-per-row="4"]').trigger('click');
    }
  }, resizeDelay);
});
